import * as React from 'react';

import { StyledList } from '../styles';
import ListItem from '../../../../containers/ImportDesktopFile/Toast/ListItem';

interface ListProps {
	filesIds: string[];
}

const List = ({ filesIds }: ListProps) => (
	<StyledList>
		{filesIds.map(id => (
			<ListItem
				key={id}
				id={id}
			/>
		))}
	</StyledList>
);

export default List;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ImportDesktopFile/Toast/List/index.tsx